/**
 * Scroll-to functionality for hash links on the document.
 *
 * @package  embark
 * @since    1.0.0
 */

/**
 * Imports jQuery.
 *
 * @see http://api.jquery.com/
 *
 * @since 1.0.0
 */
import $ from 'jquery';

/**
 * A collection of helper functions for use throughout the project.
 *
 * @since 1.0.0
 */
import * as helpers from '../global/helpers';

/**
 * Common variables used throughout the project.
 *
 * @since 1.0.0
 */
import { els, offsetAmount } from './variables';

/**
 * Scroll to hash on load.
 *
 * @since  1.0.0
 */
function scrollToHashOnLoad() {
	if (window.location.hash) {
		// To top right away.
		scroll( 0,0 );
		// Void some browsers issue.
		setTimeout(
			function() {
					scroll( 0,0 );
			}, 1
		);
		
	}
}

/**
 * Scroll to hash on click, and update URL.
 *
 * @since  1.0.0
 */
function scrollToHashOnClick() {

	if (location.pathname.replace( /^\//, '' ) == this.pathname.replace( /^\//, '' ) && location.hostname == this.hostname) {
		var hash   = this.hash;
		var target = $( hash );
		target     = target.length ? target : $( '[name=' + hash.slice( 1 ) + ']' );
		if (target.length) {

			// Disable the global user scrolled variable. See /js/modules/theme/_global-variables.js
			window.userInvokedScroll = false;

			// See variables.js for offsetAmount function.
			helpers.scrollToEl( target, offsetAmount() + 48 );
			helpers.addHashToURL( hash );

			return false;
		}
	}
}

/**
 * Resets the global window.userInvokedScroll variable to true.
 *
 * Listens for when helpers.scrollToEl() has completed.
 *
 * @since  1.0.0
 */
function resetUserInvokedScroll() {
	setTimeout( function() {
		window.userInvokedScroll = true;
	}, 1000 );
	
}

// Add an event listener for our custom event for when helpers.scrollToEl() has completed scrolling. 
// see /js/modules/global/helpers.js
window.addEventListener( 'ScrollToEl:onComplete', resetUserInvokedScroll );
window.addEventListener( 'load', scrollToHashOnLoad );
$( document ).on( 'click', 'a[href*="#"]:not([href="#"])', scrollToHashOnClick );
